<template>
  <div>
    <div class="authority" v-if="status == true">
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
    <div v-else>
      <div class="box">
        <p class="return" @click="back">返回首页</p>
        <span class="line">|</span>
        <p class="contract">系统设置</p>
        <span class="lines">></span>
        <p class="contract">账号管理</p>
      </div>
      <div class="p_btn">
        <div>
          <div class="mainTitle">账号管理</div>
        </div>
        <div data-permissions="func:acount:create" v-has>
          <button class="btn subbtn" @click="add">创建账号</button>
        </div>
      </div>
      <div class="filter">
        <div class="content">
          <div label="姓名" style="margin-bottom: 0;">
            <span class="size">姓名</span>
            <el-input
              @keyup.enter.native="searchEnterFun"
              placeholder="请输入姓名"
              v-model.trim="form.name"
              style="width: 180px;margin-left:12px"
            ></el-input>
          </div>
          <div label="手机号" style="margin-left: 28px;">
            <span class="size">手机号</span>

            <el-input
              placeholder="请输入手机号"
              @keyup.enter.native="searchEnterFun"
              v-model.trim="form.number"
              style="width: 180px;margin-left:12px"
            ></el-input>
          </div>

          <div style="margin-left: 28px;">
            <button type="button" class="btn subbtn" @click="onsubmit">
              查询
            </button>
            <button style="margin-left: 8px" class="btn" @click="onreset">
              清空
            </button>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="list"
          :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
        >
          <el-table-column label="姓名" prop="name" min-width="12" align="left" >
          </el-table-column>
          <el-table-column label="手机号" prop="mobile" min-width="15" align="left">
          </el-table-column>
          <el-table-column
            label="邮箱"
            prop="email"
            min-width="35" align="left"
          ></el-table-column>
          <el-table-column
            label="权限组"
            prop="group_name"
            min-width="14" align="left"
          ></el-table-column>
          <el-table-column label="部门" prop="org_name"             min-width="14" align="left"
>
          </el-table-column>
          <el-table-column
            label="最近登录时间"
            prop="last_login_time"
                       min-width="23" align="left"

          ></el-table-column>
          <el-table-column label="状态" prop="status"             min-width="13" align="left"
>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="span_bgc">停用中</span>
              <span v-if="scope.row.status == 1" class="span_bgc4">启用中</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"   min-width="13" align="left"
>
            <template slot-scope="scope">
              <div
                v-if="
                  btnPermissionsStr.includes('func:acount:open') ||
                  btnPermissionsStr.includes('func:acount:edit') ||
                  btnPermissionsStr.includes('func:account:editpermission')
                "
              >
                <el-dropdown
                  v-if="scope.row.admin_type !== 0"
                  placement="bottom"
                  size="small"
                >
                  <span class="el-dropdown-link menu">
                    <span></span>
                    <i>操作</i>
                  </span>

                  <el-dropdown-menu slot="dropdown">
                    <div data-permissions="func:acount:open" v-has>
                      <el-dropdown-item
                        v-if="scope.row.status == 1"
                        @click.native="
                          seal(scope.row.user_id, scope.row.status)
                        "
                        >停用</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-if="scope.row.status == 0"
                        @click.native="
                          seal(scope.row.user_id, scope.row.status)
                        "
                        >启用</el-dropdown-item
                      >
                    </div>
                    <div data-permissions="func:acount:edit" v-has>
                      <el-dropdown-item
                        @click.native="onmodify(scope.row.user_id)"
                        >编辑账号信息</el-dropdown-item
                      >
                    </div>
                    <div data-permissions="func:account:editpermission" v-has>
                      <el-dropdown-item
                        @click.native="onAuthority(scope.row.user_id)"
                        >编辑权限</el-dropdown-item
                      >
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <div class="menu" @mouseover="hqid(scope.row.id)" @mouseout="lkid">
							<span></span>
							<i>操作</i>
							<div class="card" v-if="scope.row.id == checkid">
								<p @click="seal(scope.row.id)">公司印章</p>
								<p @click="update(scope.row)">编辑</p>
								<p @click="deleteContractCompany(scope.row.id)">删除</p>
							</div>
						</div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page
        :page="pageNum"
        :pagesize.sync="pageSize"
        :total="total"
        @currentChange="cur"
        @enter="cur"
        v-show="total > 0"
        :pageNum="pageNum"
      ></page>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    //初始化数据
    this.loadData();
  },
  mounted() {
    this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");
  },
  data() {
    return {
      btnPermissionsStr: {},
      status: false,
      form: {
        name: "",
        number: "",
      },
      list: [],
      checkid: "",
      checkval: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      maskshow: false,
      masktype: "",
      id: "",
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
 
      if (keyCode == 13) {
        this.onsubmit();
      }
    },

    //搜索
    onsubmit() {
      this.pageNum = 1;
      this.loadData();
    },
    onreset() {
      this.pageNum = 1;
      this.form.name = "";
      this.form.number = "";
      this.loadData();
    },
    // 加载列表
    loadData() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.form.name,
        mobile: this.form.number,
      };
      return this.$axios
        .get("userInfo/queryList", {
          params,
        })
        .then((res) => {
          if (res.data.status == 2) {
            this.status = true;
          } else {
            this.list = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    add() {
      this.$router.push({
        path: "account/addAccount",
      });
    },

    update(id) {
      this.maskshow = true;
      this.masktype = "updatecompany";
      this.checkval = id;
      this.checkval.unit_type = 1;
    },

    onmodify(id) {
      this.$router.push({
        path: "account/addAccount",
        query: {
          id: id,
          edit: "true",
        },
      });
    },
    onAuthority(id) {
      this.$router.push({
        path: "account/jurisdiction",
        query: {
          id: id,
          edit: "true",
        },
      });
    },
    //分页方法
    cur(val) {
  
      this.pageNum = val;
      this.loadData();
    },
    search() {
      this.pageNum = 1;
      this.loadData();
    },
    seal(userId, status) {
      if (status == 1) {
        status = false;
      } else if (status == 0) {
        status = true;
      }

      return this.$axios
        .post(
          "userInfo/operateServerUser?userId=" + userId + "&status=" + status
        )
        .then((res) => {
          this.$message.success(res.data.message);

          this.loadData();
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>

<style scoped lang="less">
.tab_nav {
  border-bottom: none;
}

.form {
  margin: 23px 0;
}

.el-form-item {
  margin-bottom: 15px;
}

.span_bgc {
  padding: 2px 9px;
  background: rgba(254, 240, 240, 1);
  border-radius: 4px;
  border: 1px solid rgba(252, 210, 210, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(245, 116, 116, 1);
}

.span_bgc4 {
  padding: 2px 9px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  font-weight: 400;
  border: 1px solid #b7e1d3;

  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}
.smallTitle {
  font-size: 12px;
  font-weight: 400;
  color: #303140;
}
.filter {
  width: 100%;
  height: 57px;
  background: rgba(242, 245, 248, 1);
  border-radius: 4px;
  margin-bottom: 30px;
  .content {
    display: flex;
    line-height: 57px;
    margin-left: 10px;

  }
  size {
    font-size: 12px;
    font-weight: 400;
    color: rgba(84, 85, 102, 1);
    margin-left: 10px;
  }
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
.table /deep/ .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
     padding-left: 0;
}
</style>
